import { useEffect, useRef } from 'react';
import FileSaver from 'file-saver';
import { useToast } from "../../contexts/toast";
import { useCampaignSundriesReportMutation } from "../../generated/graphql";

type SundriesReportNewProps = {
    campaigns: any[],
    done: () => void
};

export const SundriesReportNew = ({ campaigns, done }: SundriesReportNewProps) => {
    const { toast, dismiss } = useToast();
    const [mutation] = useCampaignSundriesReportMutation({ fetchPolicy: 'no-cache' });
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        const ids = (campaigns || []).map((c) => c.id).filter(Boolean);
        if (!ids.length) {
            toast('No campaigns to report on', { variant: 'error' });
            done();
            return;
        }
        toast('Generating report', { id: 'GEN_REPORT', timeout: 0 });
        (async () => {
            try {
                const data = await mutation({ variables: { ids } });
                toast('Rendering file', { id: 'GEN_REPORT' });
                const res = await fetch(data?.data?.campaignSundriesReport?.reportData);
                const blobContent = await res.blob();
                FileSaver.saveAs(blobContent, 'other-report.xlsx');
                dismiss('GEN_REPORT');
            } catch (e) {
                dismiss('GEN_REPORT');
                toast(e && e.graphqlErrors && e.graphqlErrors.length ? e.graphqlErrors[0].debugMessage : 'Error generating report', { variant: 'error' });
            } finally {
                done();
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
